import component from './commentsButton.component'
import './commentsButton.scss'

let module = angular.module('commentsButton', [])
	.component('commentsButton', component)
	.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/commentsButton/commentsButton.js